import {
  Box,
  Button,
  Card,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { Item } from "lib/features/item/types";
import { useNavigate } from "react-router-dom";
import commission from "../../../assets/icons/Commiss.png";
import tick from "../../../assets/icons/green_tick.svg";
import members from "../../../assets/icons/light_member.svg";
import edit from "../../../assets/icons/lucide_edit.png";
import hidden from "../../../assets/icons/mdi_hide.png";
import ticket from "../../../assets/icons/ticket.svg";
import warning from "../../../assets/icons/warning.svg";
interface RefereeItemCardProps {
  item: Item;
  pressDelete: (item: Item) => void;
  pressHideShow: (item: Item) => void;
}

const FareharbourItemListCard = ({
  item,
  pressDelete,
  pressHideShow,
}: RefereeItemCardProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width: 376px)");
  const navigate = useNavigate();
  console.log("farhabour item: ", item);
  return (
    <Card
      key={item.id}
      sx={{
        marginTop: "1rem",
        fontFamily: theme.typography.fontFamily,
        borderRadius: "10px",
        width: "620px",
        position: { xs: "unset", sm: "relative" },
        height: "152px",
        boxShadow: "2px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          height: "100%",
        }}
      >
        {/* Image Container */}
        <Box sx={{ width: "271px", height: "100%" }}>
          <img
            src={item.farehabor_item_details?.image_cdn_url ?? ""}
            alt={"name"}
            style={{
              width: "100%",
              height: "100%",
              marginRight: "1rem",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              objectFit: "cover",
            }}
          />
        </Box>

        <Box
          sx={{
            width: "333px",
            height: "150px",
            display: "flex",
            flexDirection: "column",
            pt: "8px",
            pb: "16px"
          }}
        >
          {/* Details Container */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "333px",
              gap: "5px",
            }}
          >
            <Typography sx={{ fontSize: "22px", fontWeight: "600", lineHeight: "30px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {item.farehabor_item_details?.name}
            </Typography>

            {/* Info Section */}
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {/* Ticket Price */}
              {item?.farehabor_item_details?.customer_prototypes?.[0]?.total !==
                undefined && (
                  <Typography
                    sx={{
                      fontSize: "15px",
                      color: "#000000",
                      display: "flex",
                      fontWeight: 400,
                      width: "64px",
                      height: "23px",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <img
                      src={ticket}
                      alt="ticket icon"
                      style={{ width: "16px", height: "16px" }}
                    />
                    $
                    {item?.farehabor_item_details?.customer_prototypes?.[0]?.total /
                      100}
                  </Typography>
                )}

              {/* Capacity */}
              {item?.fareharbor_availabilities &&
                item?.fareharbor_availabilities[0]?.capacity && (
                  <Typography
                    sx={{
                      fontSize: "15px",
                      color: "#000000",
                      display: "flex",
                      fontWeight: 400,
                      width: "81px",
                      height: "23px",
                      alignItems: "center",
                      gap: "5px",
                      lineHeight: "22.5px",
                    }}
                  >
                    <img
                      src={members}
                      alt="members icon"
                      style={{ width: "20px", height: "20px" }}
                    />
                    {item?.fareharbor_availabilities[0]?.capacity}max
                  </Typography>
                )}

              {/*Commission*/}
              <Typography
                sx={{
                  fontSize: "15px",
                  color: "#000000",
                  fontWeight: 400,
                  height: "23px",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                <img
                  src={commission}
                  alt="comission icon"
                  style={{ width: "16px", height: "16px" }}
                />
                {item?.commission
                  ? item?.commission
                  : '-'}%
              </Typography>


            </Box>

            {/* Live or Incomplete Container */}
            {item &&
              typeof item?.commission === "number" &&
              item?.commission > 0 ? (
              <>
                {
                  item?.hide_item ? (
                    <Box sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "5px",
                    }}>
                      <img src={hidden} alt="hidden" />
                      <Typography
                        style={{
                          fontSize: "15px",
                          fontWeight: "600",
                          color: "#595959",
                        }}
                      >
                        Hidden
                      </Typography>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        paddingHorizontal: "12px",
                        gap: "5px",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={tick}
                        alt="ticket icon"
                        style={{ width: "16px", height: "16px" }}
                      />
                      <Typography
                        style={{
                          fontSize: "15px",
                          fontWeight: "700",
                          color: "#286C2A",
                        }}
                      >
                        Live
                      </Typography>
                    </Box>
                  )
                }
              </>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  paddingHorizontal: "12px",
                  gap: "5px",
                  alignItems: "center",
                }}
              >
                <img
                  src={warning}
                  alt="ticket icon"
                  style={{ width: "16px", height: "16px" }}
                />
                <Typography
                  style={{
                    fontSize: "15px",
                    fontWeight: "700",
                    color: "#D7221D",
                  }}
                >
                  Incomplete
                </Typography>
              </Box>
            )}
          </Box>
          {/* Buttons Container */}

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "315px",
              height: "31px",
              gap: "21px"
            }}
          >
            {item &&
              typeof item?.commission === "number" &&
              item?.commission > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <Button
                  sx={{
                    minWidth: "24px",
                    width: "24px",
                    height: "24px",
                    p: 0,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "#FFF",
                    },
                  }}
                  onClick={() => navigate(`/edit/basicItem/${item?.id}`)}
                >
                  <img src={edit} alt="edit" />
                </Button>

                <Button
                  sx={{
                    width: "67px",
                    height: "31px",
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "15px",
                    fontWeight: "400",
                    paddingY: "8px",
                    borderRadius: "8px",
                    border: "1px solid #000",
                  }}
                  onClick={() => {
                    pressHideShow(item);
                  }}
                >
                  {item?.hide_item ? "Show" : "Hide"}
                </Button>
              </Box>
            ) : (
              <Box>
                <Button
                  sx={{
                    width: "165px",
                    height: "31px",
                    backgroundColor: "#fff",
                    color: "#000",
                    fontSize: "15px",
                    fontWeight: "400",
                    paddingY: "8px",
                    borderRadius: "8px",
                    border: "1px solid #000",
                  }}
                  onClick={() => navigate(`/edit/basicItem/${item?.id}`)}
                >
                  Finish Integration
                </Button>
              </Box>
            )}
          </Box>
        </Box>


      </Box>
    </Card >
  );
};

export default FareharbourItemListCard;
